import API from '../index';
import { City } from '../../types/common';

const filterEnabledCities = (cities: City[]): City[] =>
  cities.filter((city) => !city.parent && city.enable);

interface Response {
  resources: City[];
}

const getCities = async (country: string): Promise<City[]> => {
  const { resources }: Response = await API.get(`/areas/${country}`);
  return filterEnabledCities(resources as City[]);
};

export default getCities;
